export default "__VITE_ASSET__BAv26ZsX__"